import { COUNTRY_DOMAINS } from '../../common/constants';

export const AppLanguageStorageKey = 'appLanguage';

export const SupportedLanguages = {
  en: 'en',
  id: 'id',
  vi: 'vi',
  zhTW: 'zh-TW',
  enSG: 'en-SG',
  enMY: 'en-MY',
} as const;
export type SupportedLanguages =
  (typeof SupportedLanguages)[keyof typeof SupportedLanguages];

export const defaultAppLanguages: SupportedLanguages[] = [
  SupportedLanguages.en,
];

export const appLanguagesBasedOnCountry: Record<string, SupportedLanguages[]> =
  {
    [COUNTRY_DOMAINS.sg]: [SupportedLanguages.enSG],
    [COUNTRY_DOMAINS.id]: [SupportedLanguages.id, ...defaultAppLanguages],
    [COUNTRY_DOMAINS.vn]: [SupportedLanguages.vi, ...defaultAppLanguages],
    [COUNTRY_DOMAINS.my]: [SupportedLanguages.enMY],
    [COUNTRY_DOMAINS.hk]: defaultAppLanguages,
    [COUNTRY_DOMAINS.tw]: [SupportedLanguages.zhTW, ...defaultAppLanguages],
  };

export const appLanguageToContentMap: Record<
  SupportedLanguages,
  {
    shortForm: string;
    longForm: string;
  }
> = {
  [SupportedLanguages.en]: {
    shortForm: 'EN',
    longForm: 'English',
  },
  [SupportedLanguages.enSG]: {
    shortForm: 'EN',
    longForm: 'English',
  },
  [SupportedLanguages.enMY]: {
    shortForm: 'EN',
    longForm: 'English',
  },
  [SupportedLanguages.id]: {
    shortForm: 'ID',
    longForm: 'Bahasa Indonesia',
  },
  [SupportedLanguages.vi]: {
    shortForm: 'VI',
    longForm: 'Việt Nam',
  },
  [SupportedLanguages.zhTW]: {
    shortForm: 'TW',
    longForm: '繁體中文',
  },
};
